import { render, staticRenderFns } from "./DialogOperationHistory.vue?vue&type=template&id=2623f54c&scoped=true"
import script from "./DialogOperationHistory.vue?vue&type=script&lang=js"
export * from "./DialogOperationHistory.vue?vue&type=script&lang=js"
import style0 from "./DialogOperationHistory.vue?vue&type=style&index=0&id=2623f54c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2623f54c",
  null
  
)

export default component.exports